import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { PrimaryButton } from "components/Buttons";
import Icon, { ICON_TYPE, ICON_SIZE } from "components/Icon";
import styled from "@emotion/styled";
import { colors, fontSize } from "style";

/**
 * AIRoleBuilderSuccess
 *
 * @param {function} onPreviewRole - Callback to preview the generated role
 */
const AIRoleBuilderSuccess = ({ onPreviewRole }) => (
  <Container>
    <IconContainer>
      <Icon type={ICON_TYPE.checkDotted} size={ICON_SIZE.xlarge} color={colors.green} />
    </IconContainer>

    <Title>
      <FormattedMessage id="AIRoleBuilder.Success.Title" />
    </Title>

    <Description>
      <FormattedMessage id="AIRoleBuilder.Success.Description" />
    </Description>

    <ButtonContainer>
      <PrimaryButton onClick={onPreviewRole}>
        <FormattedMessage id="AIRoleBuilder.Success.PreviewRole" />
      </PrimaryButton>
    </ButtonContainer>
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 2rem;
  text-align: center;
`;

const IconContainer = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h3`
  font-size: ${fontSize.large};
  font-weight: 600;
  color: ${colors.grayAnatomyBase};
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: ${fontSize.normal};
  color: ${colors.grayAnatomyLight1};
  margin-bottom: 2rem;
  max-width: 500px;
  line-height: 1.5;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

AIRoleBuilderSuccess.propTypes = {
  onPreviewRole: PropTypes.func.isRequired,
};

export default AIRoleBuilderSuccess;
